import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";
import { useMemo } from "react";

import { useProductSets } from "../apis";

const useProductSetsList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      search: debouncedSearch,
      orderBy: sorting[0]?.id ?? null,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : undefined
    }),
    [page, debouncedSearch, sorting]
  );

  const { productSets, meta, isLoading, setProductSets } =
    useProductSets(requestParams);

  return {
    productSets,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    setProductSets
  };
};

export default useProductSetsList;
